import {ORGANIZATION_USER, USER} from "../apiConstant";
import BaseApi from "../baseApi";

class OrganizationUserApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_AUTHENTICATION_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }

  getListOrganization(body) {
    return this.post(`${ORGANIZATION_USER}/list`, body);
  }

  getListChildren(param) {
    return this.post(`${ORGANIZATION_USER}/children`, param);
  }

  search(param) {
    return this.post(`${ORGANIZATION_USER}/search`, param);
  }

  createOrganization(param) {
    return this.post(`${ORGANIZATION_USER}/create/organization`, param);
  }

  updateOrganization(param) {
    return this.post(`${ORGANIZATION_USER}/update/organization`, param);
  }

  updateUser(param) {
    return this.post(`${ORGANIZATION_USER}/update/user`, param);
  }

  addUser(param) {
    return this.post(`${ORGANIZATION_USER}/add/user`, param);
  }

  removeUser(param) {
    return this.post(`${ORGANIZATION_USER}/remove/user`, param);
  }

  removeOrganization(param) {
    return this.post(`${ORGANIZATION_USER}/remove/organization`, param);
  }

  existOrgUser() {
    return this.get(`${ORGANIZATION_USER}/exist-org-user`);
  }

  getOnline() {
    return this.post(`${USER}/get-online`);
  }

}
export default OrganizationUserApi;
